import { DatePickerInput } from "@mantine/dates";
import type { MRT_Column, MRT_Header, MRT_TableInstance } from "mantine-react-table";
import { useEffect, useState } from "react";

const toStartISO = (date: Date): string => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d.toISOString();
};

const toEndISO = (date: Date): string => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d.toISOString();
};

type DateRangeFilterProps = {
    // biome-ignore lint/suspicious/noExplicitAny: row type is dynamic
    column: MRT_Column<any, unknown>;
    // biome-ignore lint/suspicious/noExplicitAny: row type is dynamic
    header: MRT_Header<any>;
    // biome-ignore lint/suspicious/noExplicitAny: row type is dynamic
    table: MRT_TableInstance<any>;
};

export const DateRangeFilter = ({ column }: DateRangeFilterProps) => {
    const filterValue = column.getFilterValue() as [Date | null, Date | null] | undefined;
    const [localValue, setLocalValue] = useState<[Date | null, Date | null]>(
        filterValue ?? [null, null],
    );

    // Sync when the filter is cleared externally (e.g. clear-all-filters button)
    useEffect(() => {
        if (!filterValue) {
            setLocalValue([null, null]);
        }
    }, [filterValue]);

    return (
        <DatePickerInput
            type="range"
            allowSingleDateInRange
            clearable
            size="xs"
            valueFormat="YYYY-MM-DD"
            placeholder="Date or range…"
            value={localValue}
            onChange={(value) => {
                const [start, end] = value;
                if (!start && !end) {
                    setLocalValue([null, null]);
                    column.setFilterValue(undefined);
                } else if (start && end) {
                    setLocalValue([start, end]);
                    column.setFilterValue([toStartISO(start), toEndISO(end)]);
                } else {
                    setLocalValue(value);
                }
            }}
            w="100%"
        />
    );
};
